import { config } from '@abyss/web/tools/config';
import { Button } from '@abyss/web/ui/Button';
import { Card } from '@abyss/web/ui/Card';
import { IconMaterial } from '@abyss/web/ui/IconMaterial';
import { useMediaQuery } from 'usehooks-ts';

import { phoneOnly } from '../ConstantsStyles';
import { BottomWrapper } from '../DataCard/DataCard.style';
import { HiddenFormSubmission } from '../ScheduleModal/ScheduleModal.style';
import { ScheduleModalHiddenForm } from '../ScheduleModal/ScheduleModalHiddenForm';

export const VirtualVisitCard = ({
  provider,
  varsToChange,
  callPingFederate,
  encryptedPayload,
  pfidAdapterId,
  refs,
  cardCTA,
}) => {
  const cdnUrl = config('CDN_BASE_URL');
  const phoneScreen = useMediaQuery(phoneOnly);

  return (
    <Card
      css={{
        'abyss-card-root': {
          minWidth: phoneScreen ? '318px' : '384px',
          display: 'flex',
          borderColor: '#F3F3F3F3',
          borderRadius: '10px',
          flexDirection: 'column',
          marginTop: '0px !important',
          '.abyss-card-section:first-child': {
            flexGrow: 1,
          },
          '&:active, &:focus, &:hover': {
            border: '2px solid $interactive2',
          },
        },
      }}
    >
      <Card.Section
        style={{
          padding: '20px 15px',
        }}
      >
        {callPingFederate &&
        provider.ssoUrl &&
        provider.partnerSpId &&
        provider.vendorId ? (
          <HiddenFormSubmission
            action={varsToChange.providerSsoOutUrl}
            data-testid={`${provider.title}-hidden-form`}
            method={callPingFederate ? 'get' : 'post'}
            target="_blank"
          >
            <ScheduleModalHiddenForm
              {...{
                callPingFederate,
                encryptedPayload,
                partnerSpId: provider.partnerSpId,
                pfidAdapterId,
                ssoOutTargetUrl: provider.ssoUrl,
                providerSsoOutUrl: varsToChange.providerSsoOutUrl,
                vendorId: provider.vendorId,
                vsid: varsToChange.vsid,
              }}
            />
            <button ref={refs[provider.key]} type="submit" />
          </HiddenFormSubmission>
        ) : null}
        <div
          style={{
            height: '50px',
            marginBottom: '10px',
          }}
        >
          <span
            css={{
              height: '100%',
              width: '100%',
              textAlign: 'left',
            }}
            data-auto-testid={`${provider.title}`}
            data-testid={`${provider.title}`}
            isStandardAnchor
            size="16px"
            variant="none"
          >
            <img
              alt={provider.title}
              src={`${cdnUrl}/${provider.providerIcon}`}
              style={{
                height: 'auto',
                maxHeight: '100%',
                width: 'auto',
                maxWidth: '50%',
                backgroundImage: 'none',
              }}
            />
          </span>
        </div>
        <BottomWrapper
          css={{
            padding: '8px 12px',
            borderTop: 'none',
          }}
          justify="left"
        >
          <Button
            data-testid={'virtual-visit-card-cta'}
            onClick={() => cardCTA(provider)}
            size="$sm"
            variant="outline"
          >
            {provider.ctaText}
            <IconMaterial css={{ marginLeft: '8px' }} icon="open_in_new" />
          </Button>
        </BottomWrapper>
      </Card.Section>
    </Card>
  );
};
